export const RE_RECORD_TEXT = {
    id: 'oe.recordAudio.reRecord',
    defaultMessage: 'Re-record',
    description: 'Label text'
};

export const RECORDING_UNAVAILABLE_TEXT = {
    id: 'oe.recordAudio.microphoneUnavailable',
    defaultMessage: 'Recording is not possible because microphone access is not available. Please upload a recording instead.',
    description: 'Label text'
};

export const START_RECORDING_TEXT = {
    id: 'oe.recordAudio.start',
    defaultMessage: 'Start recording',
    description: 'Label text'
};

export const STOP_RECORDING_TEXT = {
    id: 'oe.recordAudio.stop',
    defaultMessage: 'Stop recording',
    description: 'Label text'
};

export const PLAY_RECORDING_TEXT = {
    id: 'oe.recordAudio.play',
    defaultMessage: 'Play recording',
    description: 'Label text'
};

export const PAUSE_RECORDING_TEXT = {
    id: 'oe.recordAudio.pause',
    defaultMessage: 'Pause recording',
    description: 'Label text'
};
